import React, { useCallback, useState, useEffect } from "react";
import { configState } from "../../context/configState";
import "./pools.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import PoolTabelHead from "./PoolTableHead";
import PairCard from "./PairCard";

import SwapHeaderMenu from "../swap/SwapHeaderMenu";
import AllPoolsCard from "./AllPoolsCard";
import PoolTabelData from "./PoolTableData";
import SortButton from "./SortButton";
import { useLiquidity } from "../../hooks/useLiquidity";
import PoolTabelUserData from "./PoolTableUserData";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

import { useConfig } from "../../hooks/useConfig";
import { PoolInfo } from "../../types/configTypes";
import MoonLoader from "react-spinners/MoonLoader";
import PoolTabelUserHead from "./PoolTableUserHead";
import { showUsershowState } from "../../context/showUserState";
import { userLiqState } from "../../context/userLiqState";
import { walletState } from "../../context/walletState";
import { userNoOrYes } from "../../context/userNoOrYes";
import { pooolMapState } from "../../context/pooolMapState";

type Data = PoolInfo[];

type SortKey = keyof Data[0];

type SortOrder = "ascn" | "desc";

function sortData({
  tableData,
  sortKey,
  reverse,
  liq,
  apr,
  bond,
}: {
  tableData: Data;
  sortKey: SortKey;
  reverse: boolean;
  liq?:any;
  apr?:any;
  bond?:any;
}) {
  if (!sortKey) return tableData;
  const tempdata = tableData;
  const sortedData = tempdata.sort((a: any, b: any) => {
    if (sortKey === "pair_name")
      return a[sortKey].toString().toLowerCase() >
        b[sortKey].toString().toLowerCase()
        ? 1
        : -1;
    // return a[sortKey] > b[sortKey] ? 1 : -1;
    else if(sortKey.toLowerCase() === "apr"){
      return Number(apr[a.pair_name]) > Number(apr[b.pair_name]) ? 1 : -1;
    }
    else if(sortKey.toLowerCase() === "bonded"){
      return Number(bond[a.pair_name]) > Number(bond[b.pair_name]) ? 1 : -1;
    }
    else {
      // console.log("this is", liq, a, b, liq[a.pair_name])
      return Number(liq[a.pair_name]) > Number(liq[b.pair_name]) ? 1 : -1;
    }

    // todo: sort by apr
  });

  if (reverse) {
    return sortedData.reverse();
  }
  return sortedData;
}

const PoolList = ({tLiqMp, aprMp, uBondMp, uLiqMp}: any) => {
  const { poolsMap } = useRecoilValue(configState);
  const config = useConfig();
  const poolsList = config.getPoolsList();
  const [sortKey, setSortKey] = useState<SortKey>("pair_name");
  const [sortKey2, setSortKey2] = useState<SortKey>("pair_name");
  const [sortOrder, setSortOrder] = useState<SortOrder>("desc");
  const [sortOrder2, setSortOrder2] = useState<SortOrder>("desc");
  const [text, setText] = useState("");
  const [text2, setText2] = useState("");

  // let assets = Object.keys(assetsMap);
  // const actualSortedData = (tableData: any, reverse: boolean) => {
  //   assets.forEach((asset) => {
  //     if (poolsMap[asset] === undefined) {
  //       // poolsMap[asset] = -1;
  //     }
  //   });
  //   const sorted = tableData.sort((asset1: any, asset2: any) =>
  //     assetsMap[asset1] !== null && assetsMap[asset2] !== null
  //       ? (
  //           sortoption === "asset_name"
  //             ? assetsMap[asset1]?.display_denom.toLowerCase() >
  //               assetsMap[asset2]?.display_denom.toLowerCase()
  //             : balanceMap[asset1] > balanceMap[asset2]
  //         )
  //         ? 1
  //         : -1
  //       : -1
  //   );
  //   if (reverse) {
  //     return sorted.reverse();
  //   }
  //   return sorted;
  // };


  const sortedData1 = useCallback(
    () =>
      sortData({
        tableData: poolsList,
        sortKey: sortKey,
        reverse: sortOrder === "desc",
        liq: uLiqMp,
        apr: aprMp,
        bond: uBondMp,
      }),
    [poolsList, sortKey, sortOrder]
  );
  const sortedData2 = useCallback(
    () =>
      sortData({
        tableData: poolsList,
        sortKey: sortKey2,
        reverse: sortOrder2 === "desc",
        liq: tLiqMp,
        apr: aprMp,
      }),
    [poolsList, sortKey2, sortOrder2]
  );

  const handlesort = (sortorder: any) => {
    // setSortKey(sortkey);
    setSortOrder(sortorder === "desc" ? "ascn" : "desc");
  };
  const handlesort2 = (sortorder2: any) => {
    // setSortKey(sortkey);
    setSortOrder2(sortorder2 === "desc" ? "ascn" : "desc");
  };

  const orderby = (val: any) => {
    setSortKey(val);
  };
  const orderby2 = (val: any) => {
    setSortKey2(val);
  };

  const [activeMenu, setActiveMenu] = useState("Row");
  const [activeMenu1, setActiveMenu1] = useState("Grid");
  const [isLoading, setIsLoading] = useState(false);

  const { getPoolUserAmount } = useLiquidity();
  const [showuser, setShowUser] = useState(false);
  const yesornoUser = useRecoilValue(showUsershowState);
  const yesornoLiq = useRecoilValue(userLiqState);
  const setYesornoLiq = useSetRecoilState(userLiqState);
  // const [nooryesUser, setNooryesUser] = useState(false);
  const [nooryesUser, setNooryesUser] = useRecoilState(userNoOrYes);

  const userliqMap = useRecoilValue(configState);

  const getPools = async (pairs: any) => {
    const { userAmount } = await getPoolUserAmount(pairs.pair_name);
    return userAmount;
  };

  // let [userMap, setUserMap] = useState<Record<string, boolean>>({});
  // const setUserShow = useSetRecoilState(showUsershowState);
  // const usershowData = useRecoilValue(showUsershowState);
  const { client, address } = useRecoilValue(walletState);

  useEffect(() => {
    // setIsLoading(true);
    // const getuserr = () =>{poolsList.map(async (pairs)=>{
    //   const userA =  await getPools(pairs);
    //   if(Number(userA)){
    //     setShowUser(true);
    //     setIsLoading(false);
    //     return;
    //   }
    // })
    // setTimeout(() => {
    //   setIsLoading(false);
    // }, 10000);
    // }

    // getuserr();
    setTimeout(() => {
      setYesornoLiq({
        ...yesornoLiq,
        checkLoading: true,
      });
    }, 12000);
  }, [client]);
  
  
  const dataaa = Object.keys(uLiqMp);
  useEffect(()=>{
    if(nooryesUser.checkLoading === false && dataaa.length ){
      dataaa.forEach((values: any,keys: any)=>{

        if(uLiqMp[values] !== 0){
          setNooryesUser({checkLoading:true});
        }
      })
    }
  }, [uLiqMp, dataaa])


  const [map, setMap] = useRecoilState<any>(pooolMapState);

  return (
    <>
      <section>
        <div className="pool-subhead">
          <div className="swap-header-menu-component">
            <SwapHeaderMenu
              activeMenu={activeMenu1}
              onClick={() => setActiveMenu1("Grid")}
              name={"Grid"}
            />
            <SwapHeaderMenu
              activeMenu={activeMenu1}
              onClick={() => setActiveMenu1("Row")}
              name={"Row"}
            />
          </div>
          <div className="poolfilter">
            <div className="poolSearch">
              <div>
                <FontAwesomeIcon icon={faSearch} />
              </div>
              <input
                type="text"
                placeholder="Search Pools"
                value={text2}
                onChange={(e) => setText2(e.target.value)}
              />
            </div>

            <div>
              <SortButton handlesort={handlesort} orderby={orderby} />
            </div>
          </div>
        </div>

        {activeMenu1 === "Grid" ? (
          <div className="row">
            {
              // !isLoading ?
              (nooryesUser.checkLoading || yesornoLiq.checkLoading) ? (
                nooryesUser.checkLoading ? (
                  sortedData1()
                    .filter((val: any) => {
                      if (text2 === "") {
                        return val;
                      } else if (
                        val.pair_name
                          .toLowerCase()
                          .includes(text2.toLowerCase())
                      ) {
                        return val;
                      }
                    })
                    .map((pairs) => {
                      let t1 = config.getPoolsFirstAsset(pairs.pair_name);
                      let t2 = config.getPoolsSecondAsset(pairs.pair_name);

                      if (uLiqMp[pairs.pair_name]) {
                        return (
                          <Link
                            to={pairs.pair_name}
                            state={{ pairs: pairs, token1: t1, token2: t2 }}
                            key={pairs.pair_name+"1"}
                          >
                            <PairCard t1={t1} t2={t2} pairs={pairs} userLiq1={uLiqMp[pairs.pair_name]} userBondedAmount1={uBondMp[pairs.pair_name]} poolAPR1={aprMp[pairs.pair_name]}/>
                          </Link>
                        );
                      } else return <div key={pairs.pair_name+"1"}></div>;
                    })
                ) : (
                  <div className="nouserliquidity">
                    You need to add Liquidity first
                  </div>
                )
              ) : (
                <div className="loaderCenter">
                  <MoonLoader
                    color={"#1790FF"}
                    size={30}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </div>
              )
            }
          </div>
        ) : (
          <>
            <table className="all-pool-table">
              <PoolTabelUserHead
                sortOrder={sortOrder}
                handlesort={handlesort}
                sortKey={sortKey}
                orderby={orderby}
              />
              <tbody className="all-pool-table-data">
                {nooryesUser.checkLoading ? (
                  sortedData1()
                    .filter((val: any) => {
                      if (text2 === "") {
                        return val;
                      } else if (
                        val.pair_name
                          .toLowerCase()
                          .includes(text2.toLowerCase())
                      ) {
                        return val;
                      }
                    })
                    .map((pairs) => {
                      let t1 = config.getPoolsFirstAsset(pairs.pair_name);
                      let t2 = config.getPoolsSecondAsset(pairs.pair_name);
                      if (uLiqMp[pairs.pair_name]) {
                        return (
                          <PoolTabelUserData key={pairs.pair_name+"2"} t1={t1} t2={t2} pairs={pairs} userLiq1={uLiqMp[pairs.pair_name]} userBondedAmount1={uBondMp[pairs.pair_name]} poolAPR1={aprMp[pairs.pair_name]}/>
                        );
                      } else return <div key={pairs.pair_name+"1"}></div>;
                    })
                ) : (
                  <></>
                )}
              </tbody>
            </table>
            {!nooryesUser.checkLoading ? (
              <div className="nouserliquidity nouserliquiditytable">
                You need to add Liquidity first
              </div>
            ) : (
              <></>
            )}
          </>
        )}
      </section>
      <section>
        <div className="search-pool-head">
          <div className="allPools">All Pools</div>
          <div className="pool-subhead">
            <div className="swap-header-menu-component">
              <SwapHeaderMenu
                activeMenu={activeMenu}
                onClick={() => setActiveMenu("Grid")}
                name={"Grid"}
              />
              <SwapHeaderMenu
                activeMenu={activeMenu}
                onClick={() => setActiveMenu("Row")}
                name={"Row"}
              />
            </div>
            <div className="poolfilter">
              <div className="poolSearch">
                <div>
                  <FontAwesomeIcon icon={faSearch} />
                </div>
                <input
                  type="text"
                  placeholder="Search Pools"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
              </div>

              <div>
                <SortButton handlesort={handlesort2} orderby={orderby2} />
              </div>
            </div>
          </div>
        </div>
        {activeMenu === "Row" ? (
          <table className="all-pool-table">
            <PoolTabelHead
              sortOrder={sortOrder2}
              handlesort={handlesort2}
              sortKey={sortKey2}
              orderby={orderby2}
            />
            <tbody className="all-pool-table-data">
              {sortedData2()
                .filter((val: any) => {
                  if (text === "") {
                    return val;
                  } else if (
                    val.pair_name.toLowerCase().includes(text.toLowerCase())
                  ) {
                    return val;
                  }
                })
                .map((pairs) => {
                  let t1 = config.getPoolsFirstAsset(pairs.pair_name);
                  let t2 = config.getPoolsSecondAsset(pairs.pair_name);
                  return <PoolTabelData key={pairs.pair_name+"3"} t1={t1} t2={t2} pairs={pairs} totalLiq={map[pairs.pair_name]} poolAPR={aprMp[pairs.pair_name]}/>;
                })}
            </tbody>
          </table>
        ) : (
          <div className="row">
            {sortedData2()
              .filter((val: any) => {
                if (text === "") {
                  return val;
                } else if (
                  val.pair_name.toLowerCase().includes(text.toLowerCase())
                ) {
                  return val;
                }
              })
              .map((pairs) => {
                let t1 = config.getPoolsFirstAsset(pairs.pair_name);
                let t2 = config.getPoolsSecondAsset(pairs.pair_name);
                return (
                  <Link
                    to={pairs.pair_name}
                    state={{ pairs: pairs, token1: t1, token2: t2 }}
                    key={pairs.pair_name+"4"}
                  >
                    <AllPoolsCard t1={t1} t2={t2} pairs={pairs}  totalLiq={tLiqMp[pairs.pair_name]} poolAPR={aprMp[pairs.pair_name]}/>
                  </Link>
                );
              })}
          </div>
        )}
      </section>
    </>
  );
};

export default PoolList;
